import { render, staticRenderFns } from "./Edit_employee.vue?vue&type=template&id=37d49c6d&scoped=true&"
import script from "./Edit_employee.vue?vue&type=script&lang=js&"
export * from "./Edit_employee.vue?vue&type=script&lang=js&"
import style0 from "./Edit_employee.vue?vue&type=style&index=0&id=37d49c6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d49c6d",
  null
  
)

export default component.exports